import { Button } from '@pukka/ui-components';

interface EwalletStatusButtonsProps {
  readonly isAllInactive: boolean;
  readonly hasInactive: boolean;
  readonly isTrial?: boolean;
  readonly onClickSeeDetail: () => void;
  readonly onClickRegister: () => void;
}

function EwalletStatusButtons({ isAllInactive, hasInactive, isTrial, onClickSeeDetail, onClickRegister }: EwalletStatusButtonsProps) {
  if (isTrial) {
    return (
      <Button className="w-full" disabled>
        Start Registration
      </Button>
    );
  }

  if (isAllInactive) {
    return (
      <Button className="w-full" onClick={onClickRegister}>
        Start Registration
      </Button>
    );
  }

  return (
    <>
      <Button className="w-full" variant="secondary" onClick={onClickSeeDetail}>
        See Detail
      </Button>

      {hasInactive && (
        <Button className="w-full" onClick={onClickRegister}>
          Register Remaining Outlet(s)
        </Button>
      )}
    </>
  );
}

export { EwalletStatusButtons };
